import { render, staticRenderFns } from "./WebPartListDataDesigner.vue?vue&type=template&id=47dbc094&scoped=true&"
import script from "./WebPartListDataDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartListDataDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartListDataDesigner.vue?vue&type=style&index=0&id=47dbc094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dbc094",
  null
  
)

export default component.exports